import { convertArrowFromServerModel, convertArrowToServerModel } from './ArrowServerModel';
import { ContentTypeServerEnum } from './ContentItem';
import { BlindMapQuestionHelper } from '../content/BlindMapQuestion';
export const convertToBlindMapQuestion = (t, parentId) => {
    const arrow = convertArrowFromServerModel(t.position);
    return BlindMapQuestionHelper.build({
        title: t.title,
        position: arrow,
        cameraPosition: t.cameraPosition,
        trackingIdentifier: t.trackingIdentifier,
        id: t.guid,
        referenceIdentifier: t.referenceIdentifier,
        parentId: parentId,
    });
};
export const convertBlindMapQuestionToUpdateServerModel = (item) => {
    return {
        guid: item.id,
        title: item.title,
        position: convertArrowToServerModel(item.position),
        cameraPosition: item.cameraPosition,
        properties: {},
        referenceIdentifier: item.referenceIdentifier,
    };
};
export const convertBlindMapQuestionToCreateServerModel = (item, parentId) => {
    return {
        ...convertBlindMapQuestionToUpdateServerModel(item),
        itemType: ContentTypeServerEnum.BlindMapQuestion,
        itemId: parentId,
        trackingIdentifier: item.trackingIdentifier,
    };
};
